import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { ImportResultDTO } from '../models/importResult.model';
import { ImportExportDTO } from '../models/importExport.model';

@Injectable({
  providedIn: 'root'
})

export class ImportExportService {
  constructor(private http: HttpClient) { }

  exportTemplate(importExportDTO: ImportExportDTO) {
    return this.http.post(environment.apiFullUrl + '/ImportExport/ExportTemplate', importExportDTO, { responseType: 'blob', observe: 'response' }).toPromise();
  }

  exportFromIBaseEntity(importExportDTO: ImportExportDTO, additionalParams: any = null) {
    const formData = new FormData();

    if (!additionalParams) additionalParams = {};

    formData.append('additionalParams', JSON.stringify(additionalParams));
    formData.append('importExportDTO', JSON.stringify(importExportDTO));

    return this.http.post(environment.apiFullUrl + '/ImportExport/Export', formData, { responseType: 'blob', observe: 'response' }).toPromise();
  }

  import(fileToImport: Blob, importExportDTO: ImportExportDTO, additionalParams: any = null) {
    const formData = new FormData();
    formData.append('file', fileToImport);

    if (!additionalParams) additionalParams = {};

    formData.append('additionalParams', JSON.stringify(additionalParams));
    formData.append('importExportDTO', JSON.stringify(importExportDTO));

    return this.http.post<ImportResultDTO>(environment.apiFullUrl + '/ImportExport/Import', formData).toPromise();
  }

}
